import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // form
  serviceId: null,
  serviceContentsId: null,
  targetId: Constants.RegisterHash,
  values: {},

  // model
  snapshotModel: [],
  serviceAttributeModel: [],
  
  // データ更新の判別フラグ
  updated: false
}

const getters = {
	get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
}

const actions = {
  show ({commit}, {serviceId, serviceContentsId, appliedContentsId}) {
    // 新規作成の場合「Constants.RegisterHash」
    // コピーの場合「NoticeId」が引き渡される
    commit('setServiceId', serviceId)
    commit('setServiceContentsId', serviceContentsId)
    commit('setTargetId', appliedContentsId)

		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
  },

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {contentsSettingParams, serviceAttributeParams, contentsApplyParams}) {
    return new Promise((resolve, reject) => {
      // let contentsApplyParams = {
      //   serviceUuid: state.serviceId,
      //   appliedContentsUuid: state.appliedContentsId
      // }

      // 新規登録
      if (getters.isRegister(state)) {
        ApiManager.request(
          [
            'serviceContentsSetting',
            'serviceAttributeType'
          ],
          [
            'v1ServiceContentsSnapshotListGet',
            'v1ServiceAttributeTypeListGet'
          ],
          [
            contentsSettingParams,
            serviceAttributeParams
          ])
          .then(res => {
            let status = Utility.parseResponse(res)

            if (status.result) {
              commit('setSnapshotModel', res[0].data.contentsSnapshots)
              commit('setServiceAttributeModel', res[1].data.serviceAttributeTypes)
              commit('initRegister')
              console.log('snapshotModel', state.snapshotModel)
              console.log('serviceAttributeModel', state.serviceAttributeModel)
              resolve()

            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })

      // 変更
      } else {
        ApiManager.request(
          [
            'serviceContentsSetting',
            'serviceAttributeType',
            'serviceContentsApply'
          ],
          [
            'v1ServiceContentsSnapshotListGet',
            'v1ServiceAttributeTypeListGet',
            'v1ServiceContentsApplyDetailGet'
          ],
          [
            contentsSettingParams,
            serviceAttributeParams,
            contentsApplyParams
          ])
          .then(res => {
            let status = Utility.parseResponse(res)

            if (status.result) {
              commit('setSnapshotModel', res[0].data.contentsSnapshots)
              commit('setServiceAttributeModel', res[1].data.serviceAttributeTypes)
              commit('initModify', res[2].data.serviceAppliedContentsDetails)
              console.log('snapshotModel', state.snapshotModel)
              console.log('serviceAttributeModel', state.serviceAttributeModel)
              console.log('values', state.values)
              resolve()

            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })
      }
    })
  },

  /**
   * データ更新判別フラグの切替
   */
  setUpdated ({commit}, flag) {
    commit('setUpdated', flag)
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  setSnapshotModel (state, data) {
    data.sort(Utility.sortByKey('contentsSnapshotId', false))
    Vue.set(state, 'snapshotModel', data)
  },
  setServiceAttributeModel (state, data) {
    Vue.set(state, 'serviceAttributeModel', data)
  },

  // form
  setServiceId (state, id) {
    state.serviceId = id
  },
  setServiceContentsId (state, id) {
    state.serviceContentsId = id
  },
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state, 'values', {})
    Vue.set(state.values, 'inpDeliberyToKbn', '')
    Vue.set(state.values, 'inpLocation', null)
    Vue.set(state.values, 'inpAttribute', [])
    Vue.set(state.values, 'inpSnapshot', null)
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    //TODO すべての場合の処理
    Vue.set(state.values, 'inpDeliberyToKbn', data.deliberyToKbn)
    Vue.set(state.values, 'inpLocation', data.deliveryToLocationUuid || null)
    Vue.set(state.values, 'inpAttribute', data.deliveryToAttributeGroupUuids || [])
    Vue.set(state.values, 'inpSnapshot', data.contentsSnapshot.contentsSnapshotUuid)
  },

  // updated
  setUpdated (state, flag) {
    state.updated = flag
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
